module.exports = __webpack_public_path__ + "media/images/spree/frontend/panels/product/wellington-4e8d1de51feab74115c2ad8da37264df.jpg";